import { render, staticRenderFns } from "./registration-hosting-list.html?vue&type=template&id=f0ae4a1e&scoped=true&external"
import script from "./registration-hosting-list.js?vue&type=script&lang=js&external"
export * from "./registration-hosting-list.js?vue&type=script&lang=js&external"
import style0 from "./registration-hosting-list.scss?vue&type=style&index=0&id=f0ae4a1e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ae4a1e",
  null
  
)

export default component.exports